export enum PurchaseOrderQuotationStatus {
  CREATED = 'CREATED',       // Created but not yet receive the result
  FULFILLED = 'FULFILLED',   // Receive quotation result
  EXPIRED = 'EXPIRED',       // Need to re-quote
  FAILED = 'FAILED',         // Need to re-quote
}
